import { useEffect } from 'react';
import Lenis from 'lenis';
import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Office from './pages/Office';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import Track from './pages/Track';
import Admin from './pages/Admin';
import { Toaster } from './components/ui/toaster';
import { LanguageProvider } from './i18n/LanguageContext';
import WhatsAppButton from './components/WhatsAppButton';
import ChatWidget from './components/ChatWidget';
import { useLocation } from 'react-router-dom';

function GlobalWidgets() {
  const location = useLocation();
  if (location.pathname.startsWith('/admin')) return null;
  return (
    <>
      <WhatsAppButton />
      <ChatWidget />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <HashRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/office" element={<Office />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/track" element={<Track />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <GlobalWidgets />
        </HashRouter>
        <Toaster />
      </LanguageProvider>
    </div>
  );
}

export default App;
